import React from 'react'

export default function Badge({ children }) {
    return (
        <p
            className='m-0 p-2 position-absolute bg-primary fw-extrabold shadow'
            style={{ top: 16, left: 8, fontSize: 14 }}
        >
            {children}
        </p>
    )
}